import { feathers } from '@/feathers-client';
import Vue from 'vue';
import { CookieStorage } from 'cookie-storage';
import userInformation from '@/Core/store/user-information';
import store from '../store';


const A_MONTH_FROM_TODAY = new Date(Date.now() + 2592000000);
const domain = window.location.hostname.split('.').slice(1).join('.') || window.location.hostname;
const cookieStorage = new CookieStorage({ expires: A_MONTH_FROM_TODAY, path: '/', domain });

export function checkUser() {
  return new Promise(res => {
    Vue.http.post('session/create_user').then(user => {
      res(user);
    });
  });
}

const setCookie = (key, value) => {
  cookieStorage.setItem(key, value, null, null, process.env.VUE_APP_MAIN_DOMAIN);
};

// Helper function to check if current route is sunset-admin (standalone page)
function isSunsetAdminRoute() {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/sunset-admin');
}

export async function validate() {
  // Skip authentication validation for sunset-admin routes (standalone page)
  if (isSunsetAdminRoute()) {
    return true;
  }
  
  const LD_AUTH = cookieStorage.getItem('LD_AUTH');
  if (!LD_AUTH) {
    const redirect = encodeURIComponent(window.location.href);
    const newLocation = `${process.env.VUE_APP_ACCOUNTS_APP_URL}/signin?ref=${redirect}`;
    window.location.assign(newLocation);
    return false;
  }
  // Send validation check
  return feathers
    .service('sessions')
    .find()
    .then(res => {
      setCookie('LD_CRM_APP_AUTHORIZED', true);
      store.dispatch('userInformation/getUser').then(user => {
        saveUserInfoInStore(user);
        store.dispatch('authentication/validateToken').then(() => {
          // Token exists and is valid
          const { user } = userInformation.state;

           // Check if we've already done the redirect check for this session
           const hasCheckedRedirect = cookieStorage.getItem('LD_REDIRECT_CHECKED');
          
           if (user && user.feature_flags.includes('nylas-ms-reauth') && !hasCheckedRedirect) {
             // Set flag to prevent future redirects in this session
             setCookie('LD_REDIRECT_CHECKED', true);
             const newLocation = '/email-integrations';
             window.location.assign(newLocation);
             return;
           }

          if (!user) {
            store.dispatch('userInformation/getUser').then(newUser => {
              store.dispatch('authentication/loginSuccess', { accessToken: cookieStorage.getItem('LD_AUTH'), user: newUser.id });
            });
          }
        });
      });
      return true;
    })
    .catch(err => {
      const accountsAppUrl = `${process.env.VUE_APP_ACCOUNTS_APP_URL}`;
      const LD_CRM_APP_AUTHORIZED = cookieStorage.getItem('LD_CRM_APP_AUTHORIZED');
      const errorMsg = err.message;
      const redirect = encodeURIComponent(window.location.href);
      let newLocation;
      if (errorMsg.includes('ERR001')) {
        // This user has been blocked in the whitelist feature
        // Do not destroy his session
        setCookie('LD_REDIRECT_URL', redirect);
        setCookie('LD_CRM_APP_AUTHORIZED', false);
        newLocation = `${accountsAppUrl}/home?errorMsg=${errorMsg}`;
      } else if (errorMsg.includes('ERR002')) {
        // This user does not have a valid subscription
        // Do not destroy his session
        setCookie('LD_REDIRECT_URL', redirect);
        setCookie('LD_CRM_APP_AUTHORIZED', false);
        newLocation = `${accountsAppUrl}/settings?errorMsg=${errorMsg}`;
        newLocation = newLocation.replace(/ /g, '%20');
        window.location.assign(newLocation);
      } else if (LD_CRM_APP_AUTHORIZED) {
        store.dispatch('userInformation/resetUser');
        store.dispatch('authentication/logout');
      }
      return true;
    });
}

function saveUserInfoInStore(userInfo) {
  store.commit('ldAppLayout/userInfo', userInfo);
  store.commit('subscription/setFeatures', userInfo, { root: true });
  store.commit('subscription/setPlan', userInfo, { root: true });
  store.commit('subscription/setPaymentConfigured', userInfo, { root: true });
  store.commit('subscription/setEmailVerified', userInfo, { root: true });
  store.commit('subscription/setHasCustomNumber', userInfo, { root: true });
}